//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultLayout from '~/layouts/default.vue';
import PrimaryHeader from '~/components/headers/PrimaryHeader';

export default {
	name: 'head-hunting',

	components: {
		DefaultLayout,
		PrimaryHeader,
	},

	data() {
		return {
			showAddGroupDialog: false,
		};
	},

	methods: {
		openAddGroupDialog() {
			this.showAddGroupDialog = true;
		},

		closeAddGroupDialog() {
			this.showAddGroupDialog = false;
			window.location.reload();
		},
	},
};
